import type { Messages } from '../i18n/messages';

export const cliAuthMessages: Messages = {
  'cliAuth.title': { en: 'Command-line sign-in', fun: 'Terminal handshake' },
  'cliAuth.working': {
    en: 'Authorizing the CLI…',
    fun: 'Wiring up your terminal…',
  },
  'cliAuth.done': {
    en: 'CLI authorized — you can close this tab and return to your terminal.',
    fun: "Terminal's in. Close this tab and head back.",
  },
  'cliAuth.error.redirect': {
    en: 'Invalid or missing callback address — the CLI must pass a localhost redirect.',
    fun: 'That callback address looks off — expected a localhost handback.',
  },
  'cliAuth.error.noToken': {
    en: "Couldn't read your credentials. Are you signed in?",
    fun: 'No credentials found — sign in first?',
  },
  'cliAuth.error.generic': {
    en: 'Failed to authorize the CLI.',
    fun: "Couldn't authorize the terminal.",
  },
  'cliAuth.consent.title': {
    en: 'Authorize the command-line tool?',
    fun: 'Let the terminal in?',
  },
  'cliAuth.consent.body': {
    en: 'This signs you in as {user} and sends a token to {host}. Only continue if you just started this from your terminal.',
    fun: 'This signs you in as {user} and hands a token to {host}. Only continue if you just kicked this off from your terminal.',
  },
  'cliAuth.consent.code': {
    en: 'Confirm this code matches your terminal: {code}',
    fun: 'Match this code with your terminal: {code}',
  },
  'cliAuth.consent.authorize': { en: 'Authorize', fun: 'Let it in' },
};
